import { render, staticRenderFns } from "./PackagingTypesModule.vue?vue&type=template&id=a29d0b50"
import script from "./PackagingTypesModule.vue?vue&type=script&lang=js"
export * from "./PackagingTypesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports